/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions } from './FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions';
import {
    instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions,
    FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsFromJSON,
    FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsToJSON,
} from './FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions';

/**
 * @type FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegram
 * 
 * @export
 */
export type FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegram = FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions;

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegramFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegram {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegramFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegramFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegram {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegramToJSON(json: any): any {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegramToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegramToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateFromSocialRequestTelegram | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptionsToJSON(value as FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoAuthTelegramOptions);
    }

    return {};
}

